module.exports = __webpack_public_path__ + "static/media/15c-02_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.d4b803a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15c/15c-02_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 164
// module chunks = 0